import { render } from "./FooterRegionSwitcher.vue?vue&type=template&id=3f9bfd18&scoped=true"
import script from "./FooterRegionSwitcher.vue?vue&type=script&lang=js"
export * from "./FooterRegionSwitcher.vue?vue&type=script&lang=js"

import "./FooterRegionSwitcher.vue?vue&type=style&index=0&id=3f9bfd18&scoped=true&lang=css"

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9bfd18"]])

export default __exports__